import { render, staticRenderFns } from "./AssessmentReportDDS.vue?vue&type=template&id=ce2b8622&scoped=true"
import script from "./AssessmentReportDDS.vue?vue&type=script&lang=js"
export * from "./AssessmentReportDDS.vue?vue&type=script&lang=js"
import style0 from "./AssessmentReportDDS.vue?vue&type=style&index=0&id=ce2b8622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2b8622",
  null
  
)

export default component.exports